import { Box, Stack, Typography } from '@mui/material';

import Container from 'components/Container';
import { baseColors } from 'utils/constants';

import creditCard from 'assets/images/Cloud/credit-card.svg';
import cartHistory from 'assets/images/Cloud/cart-history.svg';

type Props = {
  onPurchaseHistoryClick: () => void;
  onCreditCardClick: () => void;
};

type TileProps = {
  iconSrc: string;
  iconAlt: string;
  iconSize: { width: number; height: number };
  label: React.ReactNode;
  onClick: () => void;
};

const Tile = ({ iconSrc, iconAlt, iconSize, label, onClick }: TileProps) => {
  return (
    <Box
      sx={{
        flex: 1,
        maxWidth: 160,
        height: 120,
        bgcolor: baseColors.cloudOrange,
        borderRadius: 1.5,
        color: baseColors.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer'
      }}
      onClick={onClick}
    >
      <Stack spacing={1} alignItems="center">
        <Typography sx={{ fontWeight: 800, fontSize: 13, textAlign: 'center', lineHeight: 1.5 }}>{label}</Typography>
        <Box component="img" src={iconSrc} alt={iconAlt} sx={{ width: iconSize.width, height: iconSize.height }} />
      </Stack>
    </Box>
  );
};

const CloudQuickMenu = ({ onPurchaseHistoryClick, onCreditCardClick }: Props) => {
  return (
    <Container sx={{ px: 2, pt: 3 }}>
      <Stack direction="row" spacing={2} justifyContent="center">
        <Tile
          iconSrc={cartHistory}
          iconAlt="購入履歴・領収書"
          iconSize={{ width: 50, height: 40 }}
          onClick={onPurchaseHistoryClick}
          label={
            <>
              購入履歴
              <br />
              領収書
            </>
          }
        />
        <Tile
          iconSrc={creditCard}
          iconAlt="クレジットカード情報"
          iconSize={{ width: 40, height: 40 }}
          onClick={onCreditCardClick}
          label={
            <>
              クレジットカード
              <br />
              情報
            </>
          }
        />
      </Stack>
    </Container>
  );
};

export default CloudQuickMenu;
